import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AlerteDto } from "../../../../dto/GenApi.iNotPaie.Dto/AlerteDto";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants from "../../../Controls/EventConstants";
import $ from "jquery";
import { TypeAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/TypeAlerte";
import { NiveauAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/NiveauAlerte";

@Component
export default class ModalCardAlert extends Vue {
	@Prop()
	public alertes: AlerteDto[] = [];

	@Prop()
	public isUtilisateurPst = false;

	@Prop()
	public isAdmin = false;

	@Prop()
	public isAdminPst = false;

	@Prop()
	public isPayeur = false;

	public getClass(type: NiveauAlerte): string {
    	let classFa = "";

    	switch (type) {
    		case NiveauAlerte.Critique:
    			classFa = "critical";
    			break;
    		case NiveauAlerte.Majeur:
    			classFa = "red";
    			break;
    		case NiveauAlerte.Intermediaire:
    			classFa = "orange";
    			break;
    		case NiveauAlerte.Mineur:
    			classFa = "yellow";
    			break;
    	}

    	return classFa;
	}

	public clickEvent(alerte: AlerteDto): void {
    	if (alerte.FullNameSalarie == undefined) {
    		if (alerte.TypeAlerte == TypeAlerte.ClotureDSN) {
    			EventBus.NavigateTo({ path: "/dsn" });
    		} else if (alerte.TypeAlerte == TypeAlerte.DpaeARealiser) {
    			EventBus.NavigateTo({ path: "/dpae" });
    		} else if (alerte.TypeAlerte == TypeAlerte.ClotureExercice) {
    			EventBus.$emit(EventConstants.MODAL_CLOTURE_PAIE);
    		}
    	} else {
    		if ((this.isAdmin || this.isAdminPst || this.isPayeur) && alerte.TypeAlerte == TypeAlerte.FinPrevisionnelleCDD) {
    			this.openQualification(alerte.IdSalarie, alerte.FullNameSalarie);
    		} else if (this.isUtilisateurPst) {
    			this.openEntree(alerte.IdSalarie, alerte.FullNameSalarie);
    		} else {
    			this.openSalarie(alerte.IdSalarie, alerte.FullNameSalarie);
    		}
    	}

    	$("#modalCardAlert").modal("hide");
	}

	public openSalarie(idSalarie: number, libelle: string): void {
    	EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: libelle } });
	}

	public openEntree(id: number, libelle: string): void {
    	EventBus.NavigateTo({ path: "/entreeSalarie/" + id, query: { titre: libelle } });
	}

	public openQualification(idSalarie: number, libelle: string): void {
    	EventBus.NavigateTo({
    		path: "/ficheSalarie/" + idSalarie,
    		query: { titre: libelle, onglet: "4" }
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/home/modals/modalCardAlert/modalCardAlert.ts